import React, { useState, useEffect } from "react";
import AdminLayout from "./AdminLayout";
import "./AdminForm.css";
import { API_BASE_URL } from "./apiConfig";

const ProductMaster = () => {
  const [activeTab, setActiveTab] = useState("entry");
  const [parties, setParties] = useState([]);
  const [products, setProducts] = useState([]);
  const [form, setForm] = useState({ partyId: "", productName: "", defaultRate: "" });
  const [message, setMessage] = useState({ type: "", text: "" });
  const [loading, setLoading] = useState(true);

  const loadParties = async () => {
    const res = await fetch(`${API_BASE_URL}/party`);
    setParties(await res.json());
  };

  const loadProducts = async () => {
    setLoading(true);
    try {
      const res = await fetch(`${API_BASE_URL}/product/all`);
      setProducts(await res.json());
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { loadParties(); loadProducts(); }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.partyId) {
      setMessage({ type: "error", text: "Please select a party." });
      return;
    }
    if (!form.productName.trim()) {
      setMessage({ type: "error", text: "Product name is required." });
      return;
    }

    const res = await fetch(`${API_BASE_URL}/product`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        partyId: parseInt(form.partyId, 10),
        productName: form.productName,
        defaultRate: parseFloat(form.defaultRate) || 0,
      }),
    });

    if (res.ok) {
      setMessage({ type: "success", text: "Product added successfully." });
      setForm({ partyId: form.partyId, productName: "", defaultRate: "" });
      loadProducts();
      setActiveTab("view");
    } else {
      setMessage({ type: "error", text: "Could not save product." });
    }
  };

  return (
    <AdminLayout>
      <div className="page-header">
        <h1 className="page-title">Product Master</h1>
      </div>

      <div className="content-card">
        <div className="tab-container">
          <button
            className={`tab-btn ${activeTab === "entry" ? "active" : ""}`}
            onClick={() => setActiveTab("entry")}
          >
            Create New Product
          </button>
          <button
            className={`tab-btn ${activeTab === "view" ? "active" : ""}`}
            onClick={() => setActiveTab("view")}
          >
            View Records ({products.length})
          </button>
        </div>

        {activeTab === "entry" && (
          <div className="form-wrapper">
            {message.text && (
              <div className={`alert ${message.type === "success" ? "alert-success" : "alert-error"}`}>
                {message.text}
              </div>
            )}

            <form onSubmit={handleSubmit}>
              <div className="form-grid">
                <div className="form-group">
                  <label>Party / Company *</label>
                  <select
                    className="form-control"
                    value={form.partyId}
                    onChange={(e) => setForm({ ...form, partyId: e.target.value })}
                    required
                  >
                    <option value="">-- Select Party --</option>
                    {parties.map((p) => (
                      <option key={p.partyId} value={p.partyId}>{p.partyName}</option>
                    ))}
                  </select>
                </div>
                <div className="form-group">
                  <label>Product Name *</label>
                  <input
                    className="form-control"
                    value={form.productName}
                    onChange={(e) => setForm({ ...form, productName: e.target.value })}
                    required
                  />
                </div>
                <div className="form-group">
                  <label>Default Rate</label>
                  <input
                    type="number"
                    className="form-control"
                    value={form.defaultRate}
                    onChange={(e) => setForm({ ...form, defaultRate: e.target.value })}
                  />
                </div>
              </div>

              <button type="submit" className="btn-submit">Add Product</button>
            </form>
          </div>
        )}

        {activeTab === "view" && (
          <div className="table-wrap">
            {loading ? (
              <div className="empty-state">Loading records...</div>
            ) : (
              <table className="data-table">
                <thead>
                  <tr>
                    <th>Party</th>
                    <th>Product</th>
                    <th>Default Rate</th>
                  </tr>
                </thead>
                <tbody>
                  {products.length > 0 ? (
                    products.map((p) => (
                      <tr key={p.productId}>
                        <td><strong>{p.partyName}</strong></td>
                        <td>{p.productName}</td>
                        <td>{p.defaultRate}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="3" className="empty-state">
                        <div style={{ marginBottom: "8px", fontSize: "1.2rem" }}>📦</div>
                        No products found.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            )}
          </div>
        )}
      </div>
    </AdminLayout>
  );
};

export default ProductMaster;